import { useTranslation } from "react-i18next";
import { LEGAL_META } from "@/content/legalDocs";

export function LegalFooter({ className = "" }) {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0];
  const pfx = lang === "fr" ? "/fr" : "";
  const links = [
    ["terms", t("legal.linkTerms")],
    ["privacy", t("legal.linkPrivacy")],
    ["ai-use", t("legal.linkAiUse")],
    ["cookies", t("legal.linkCookies")],
  ];
  return (
    <div className={`text-xs text-slatebody flex flex-wrap items-center justify-center gap-x-2 gap-y-1 ${className}`} data-testid="legal-footer">
      {links.map(([slug, label]) => (
        <span key={slug} className="inline-flex items-center gap-2">
          <a href={`${pfx}/${slug}`} target="_blank" rel="noopener noreferrer" className="hover:text-navy transition-colors" data-testid={`legal-footer-${slug}`}>{label}</a>
          <span aria-hidden="true">·</span>
        </span>
      ))}
      <span data-testid="legal-footer-copyright">© 2026 {LEGAL_META.entity}</span>
    </div>
  );
}
